import Vue from 'vue';

import { gsap } from 'gsap';
import Hammer from 'hammerjs';
import lazySizes from 'lazysizes';
import { SplitText } from '../gsap-bonus/SplitText';

Vue.component('home-intro-component', {
    props: {
        slides: {
            type: Array,
            default: () => [],
        },
    },

    filters: {
        leadingZero: (number) => {
            const string = number.toString();
            return (`0${string}`).slice(-2);
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentIndex: 0,
            transition: 'slide-next',
            inTransition: false,
            direction: 0,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.initReveal();

        const elements = this.$el.querySelectorAll('.home-slider__image');

        for (let index = 0; index < elements.length; index++) {
            const element = elements[index];
            lazySizes.loader.unveil(element);
        }

        this.isTouchDevice = document.querySelector('html').classList.contains('touchevents');

        if (this.isTouchDevice) {
            this.initHammerTime();
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initReveal() {
            this.mySplitText = new SplitText(this.$el.querySelector('.home-intro__title'), { type: 'lines', linesClass: 'line-reveal-line' });

            const linesText = [];

            for (let index = 0; index < this.mySplitText.lines.length; index++) {
                const line = this.mySplitText.lines[index];

                let inner = line.innerHTML;
                inner = `<div class="line-reveal-line__text">${inner}</div>`;
                line.innerHTML = inner;

                linesText.push(line.querySelector('.line-reveal-line__text'));
            }

            this.revealTl = gsap.timeline({
                paused: true,
                // delay: 0.2,
                onComplete: () => {
                    this.mySplitText.revert();
                    this.autoplay();
                },
            });

            if (window.matchMedia('(max-width: 767px)').matches) {
                this.revealTl.to('.home-slider__image-holder', { duration: 0.8, autoAlpha: 1, ease: 'power2.inOut' }, 0);
                this.revealTl.to('.home-slider__image-holder', { duration: 3, y: 0, ease: 'power2.inOut' }, 0);
                this.revealTl.to('.home-slider__image-overlay-reveal', { duration: 2.2, y: '-100%', ease: 'power3.inOut' }, 0);
                this.revealTl.to('.home-intro__title .line-reveal-line__text', {
                    duration: 2, y: '0%', autoAlpha: 1, stagger: 0.3, ease: 'power4.out',
                }, 0);
                this.revealTl.to(['.home-slider__info-item-category', '.home-slider__info-item-title', '.home-slider__navigation'], {
                    duration: 1, autoAlpha: 1, ease: 'power3.out',
                }, 1.7);
                this.revealTl.to('.project-card__button', {
                    duration: 1, autoAlpha: 1, ease: 'power3.out',
                }, 1.9);
            } else {
                this.revealTl.to('.home-slider__image-holder', { duration: 0.8, autoAlpha: 1, ease: 'power2.inOut' });
                this.revealTl.to('.home-slider__image-holder', { duration: 3, y: 0, ease: 'power2.inOut' }, 0);
                this.revealTl.to('.home-slider__image-overlay-reveal', { duration: 2.2, y: '-100%', ease: 'power3.inOut' }, 0);
                this.revealTl.to('.home-intro__title .line-reveal-line__text', {
                    duration: 2, y: '0%', autoAlpha: 1, stagger: 0.3, ease: 'power4.out',
                }, 1.1);
                this.revealTl.to(['.home-slider__info-item-category', '.home-slider__info-item-title', '.home-slider__navigation'], {
                    duration: 1, autoAlpha: 1, ease: 'power3.out',
                }, 1.7);
                this.revealTl.to('.project-card__button', {
                    duration: 1, autoAlpha: 1, ease: 'power3.out',
                }, 1.9);
            }

            this.revealTl.play();
        },

        initHammerTime() {
            this.hammertime = new Hammer(this.$el, {});
            this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });

            this.hammertime.on('swipeleft', () => {
                this.direction = 1;
                this.next();
            });

            this.hammertime.on('swiperight', () => {
                this.direction = 0;
                this.previous();
            });
        },

        autoplay() {
            // Kill the previous tween
            gsap.killTweensOf(this.next);

            Vue.nextTick(() => {
                // Reset it
                gsap.delayedCall(3, this.next);
            });
        },

        next() {
            if (this.inTransition) {
                return;
            }

            if (this.currentIndex === this.slides.length - 1) {
                this.currentIndex = 0;
                return;
            }

            this.currentIndex += 1;
        },

        previous() {
            if (this.inTransition) {
                return;
            }

            if (this.currentIndex === 0) {
                this.currentIndex = this.slides.length - 1;
                return;
            }

            this.currentIndex -= 1;
        },

        // Enter

        beforeEnter(el) {
            this.inTransition = true;
            gsap.set(el, { y: '100%' });
            gsap.set(el.querySelector('.home-slider__image'), { scale: 1.3 });
        },

        enter(el, done) {
            const tl = gsap.timeline({ onComplete: done });

            tl.to(el, {
                duration: 2.2, y: '0%', ease: 'power3.inOut',
            }, 0);

            tl.to(el.querySelector('.home-slider__image'), {
                duration: 2.2, scale: 1, ease: 'power3.inOut',
            }, 0);
        },

        afterEnter(el) {
            this.inTransition = false;
            this.autoplay();
        },

        beforeEnterContent(el) {
            gsap.set(el, { autoAlpha: 0 });
        },

        enterContent(el, done) {
            const tl = gsap.timeline({ onComplete: done });

            tl.to(el, { duration: 0.8, autoAlpha: 1, ease: 'power3.inOut' }, 1.5);
        },

        afterEnterContent(el) {

        },

        // Leave
        beforeLeave(el) {

        },

        leave(el, done) {
            const tl = gsap.timeline({ onComplete: done });

            tl.to(el, { duration: 2.2, y: '-100%', ease: 'power3.inOut' }, 0);

            tl.to(el.querySelector('.home-slider__image'), { duration: 2.2, scale: 1.2, ease: 'power3.inOut' }, 0);
        },

        afterLeave(el) {

        },

        leaveContent(el, done) {
            const tl = gsap.timeline({ onComplete: done });

            tl.to(el, { duration: 0.8, autoAlpha: 0, ease: 'power3.inOut' }, 0);
        },

        afterLeaveContent(el) {

        },
    },
});
